/**
 * Add a slight delay to request animation frame
 *
 * @param {function} fn
 */
export function requestAnimationFrame( fn ) {
	return window.requestAnimationFrame( () => window.requestAnimationFrame( fn ) );
}

/**
 * Execute a function after the transition has ended - once
 *
 * @param {HTMLElement} node
 * @param {function} fn
 * @param {string} the property to transition after in case transitions are different speeds
 */
export function afterTransition( node, fn, property = null ) {
	const transitionend = (e) => {
		if ( e.target === node ) {
			if ( property && e.propertyName !== property ) {
				return;
			}
		}

		node.removeEventListener( 'transitionend', transitionend );
		fn(e);
	}

	node.addEventListener( 'transitionend', transitionend );
}
